import { Link } from 'react-router-dom';

import { campaign } from './campaign';

const smsTerms = [
  `Program name: ${campaign.committee}.`,
  'Product description: political campaign updates, voter information, volunteer opportunities, event reminders, donation requests, and election reminders.',
  `Mobile opt-in locations: the homepage signup form at https://${campaign.domain}/ and the contact form at https://${campaign.domain}/contact. On either form, the phone field is optional and SMS opt-in requires checking the optional SMS consent checkbox.`,
  'Message frequency varies.',
  'Message and data rates may apply.',
  'Reply STOP to opt out. Reply HELP for help.',
  'Donations may be solicited. Donations are secured through the campaign donation processor.',
  'Consent to receive text messages is not a condition of donating, volunteering, voting, or receiving campaign information.',
];

export default function TermsAndConditions() {
  return (
    <main className="bg-[#f8f1fb] px-4 py-16 text-[#281331] sm:px-6 lg:px-8">
      <div className="mx-auto max-w-4xl rounded-[2rem] bg-white p-8 shadow-2xl lg:p-12">
        <p className="text-sm font-black uppercase tracking-[0.2em] text-[#8f6400]">
          Terms and Conditions
        </p>
        <h1 className="mt-3 text-4xl font-black text-[#6f2182]">Website and SMS Terms</h1>
        <p className="mt-4 text-sm font-bold text-[#64748b]">Effective date: May 5, 2026</p>
        <p className="mt-6 leading-8 text-[#66546f]">
          By using this website, submitting a form, donating, volunteering, or choosing to receive
          text messages, you agree to these Terms and Conditions for {campaign.committee}.
        </p>

        <section className="mt-10">
          <h2 className="text-2xl font-black text-[#6f2182]">Website use</h2>
          <p className="mt-4 leading-8 text-[#66546f]">
            You agree to use this site lawfully and not attempt to disrupt the site, submit false
            information, or misuse campaign forms. We may update, suspend, or remove site content at
            any time.
          </p>
        </section>

        <section className="mt-10">
          <h2 className="text-2xl font-black text-[#6f2182]">SMS program terms</h2>
          <p className="mt-4 leading-8 text-[#66546f]">
            If you provide your phone number and check the optional SMS opt-in checkbox on a
            campaign form, you consent to receive manually sent political text messages from{' '}
            {campaign.committee}.
          </p>
          <ul className="mt-4 list-disc space-y-3 pl-6 leading-7 text-[#66546f]">
            {smsTerms.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </section>

        <section className="mt-10">
          <h2 className="text-2xl font-black text-[#6f2182]">Privacy</h2>
          <p className="mt-4 leading-8 text-[#66546f]">
            Our{' '}
            <Link to="/privacy-policy" className="font-bold text-[#6f2182] underline">
              Privacy Policy
            </Link>{' '}
            explains how information is collected, used, and protected, including SMS opt-in and
            mobile information.
          </p>
        </section>

        <section className="mt-10">
          <h2 className="text-2xl font-black text-[#6f2182]">Contact</h2>
          <p className="mt-4 leading-8 text-[#66546f]">
            Questions about these terms may be sent to{' '}
            <a href={`mailto:${campaign.email}`} className="font-bold text-[#6f2182] underline">
              {campaign.email}
            </a>
            .
          </p>
        </section>
      </div>
    </main>
  );
}
